module.exports = __webpack_public_path__ + "img/brand-cases11.d9362fab.png";